import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Chip,
  Container,
  Stack,
  Typography,
  Card,
  CardContent,
  Link,
  Paper,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import {
  LIST_OF_VEHICLE,
  RAISE_UNBLOCK_VEHICLE,
  UPLOAD_DCUMENT,
  GET_BLOCKED_TRANSPORTER_VEHICLE_LIST,
  GET_TRANSPORTER_VEHICLE_LIST,
  DOWNLOAD_DOCUMENT,
  authKey,
} from "../../../common/URLs";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import jwt from "jwt-decode";
import { stakeholderType } from "../../../common/spinLoader";
import { toast } from "react-toastify";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { loaderService } from "../../../common/custom-loader/loader-service";
import apiClient from "../../../axios";
import {
  allowedFileTypes,
  FILE_NAME_VALIDATION_ERROR,
} from "../../../common/constants";
import { fileNameValidation } from "../../../common/commonValidations";
import CloseIcon from "@mui/icons-material/Close";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DescriptionIcon from "@mui/icons-material/Description";

export default function ListOfVehicle() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const decoded = jwt(getLocalStorageItem("id_token"));
  const [selectedRows, setSelectedRows] = useState([]);
  const [isApiCalled, setIsApiCalled] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const handleConfirmOpen = () => setConfirmOpen(true);
  const handleConfirmClose = () => setConfirmOpen(false);
  const [selectedFile, setSelectedFile] = useState();
  const [fileuploadError, setFileuploadError] = useState("");
  const [docsMap, setDocsMap] = useState({});

  const decoded_urn = decoded.extension_URN;

  const fetchVehicleList = async () => {
    setLoading(true);
    try {
      const payload = {
        stakeholderUrn: decoded_urn,
        stakeholderType: getLocalStorageItem("stakeholderCategory"),
      };

      const response = await axios.post(GET_TRANSPORTER_VEHICLE_LIST, payload, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("id_token"),
          "Content-Type": "application/json",
        },
      });

      const list = response.data?.transporterVehicleStatusList || [];
      const mappedRows = list.map((item) => ({
        id: item.vehicleNumber,
        stakeholderUrn: item.stakeholderUrn,
        vehicleBlockedRequestNumber: item.vehicleBlockedRequestNumber,
        vehicleNo: item.vehicleNumber || "",
        status: item.isVehicleBlocked ? "BLOCKED" : "ACTIVE",
        isRequestSentForUnblock: item.isRequestSentForUnblock,
        isUnblockedRequestApproved: item.isUnblockedRequestApproved,
        vehicleBlockedComment: item.blockedVehicleComment,
        vehicleBlockrequestDocumentList: item.vehicleBlockrequestDocumentList || [],
        unblockDocs: item.vehicleUnBlockrequestDocumentList || [],
        unblockComment: item.unblockedVehicleComment,
      }));

      setRows(mappedRows);
    } catch (error) {
      console.error("Error fetching blocked vehicle list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVehicleList();
  }, []);

  const handleBulkUnblockRequest = async () => {
    const selectedRowData = rows.filter((row) => selectedRows.includes(row.id));

    const hasEmptyComment = selectedRowData.some(
      (row) => !row.unblockComment || row.unblockComment.trim() === ""
    );

    if (hasEmptyComment) {
      toast.error("Comments are mandatory");
      return;
    }

    const payload = {
      raiseRequestForVehicleUnblocks: selectedRowData.map((row) => ({
        vehicleBlockedRequestNumber: row.vehicleBlockedRequestNumber,
        stakeholderType: getLocalStorageItem("stakeholderCategory"),
        stakeholderUrn: decoded_urn,
        vehicleNo: row.vehicleNo,
        vehicleUnBlockedComment: row.unblockComment,
        unBlockVehicleDocumentsList: (row.unblockDocs || []).map((doc) => ({
          unBLockVehicleFileId: doc.unBLockVehicleFileId,
          unBLockVehicleFileName: doc.unBLockVehicleFileName,
          containerName: doc.containerName,
        })),
      })),
      roleName: getLocalStorageItem("roleName"),
    };

    loaderService.showLoader();
    return await apiClient
      .post(RAISE_UNBLOCK_VEHICLE, payload, {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem("id_token"),
        },
      })
      .then((response) => {
        if (response.data.isSuccess === true) {
          setSelectedRows([]);
          fetchVehicleList();
          toast.success("Unblock request raised successfully");
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        toast.error("Failed to raise unblock request");
        loaderService.hideLoader();
        toast.error(error.message);
      });
  };

  const onRaiseUnblockButtonClick = () => {
    if (selectedRows.length === 0) {
      toast.error("Please select at least one vehicle");
      return;
    }

    const selectedRowData = rows.filter((row) => selectedRows.includes(row.id));

    const hasEmptyComment = selectedRowData.some(
      (row) => !row.unblockComment || row.unblockComment.trim() === ""
    );

    if (hasEmptyComment) {
      toast.error("Comments are mandatory");
      return;
    }

    handleConfirmOpen();
  };

  const handleUnblockCommentChange = (vehicleNumber, value) => {
    setRows((prev) =>
      prev.map((row) =>
        row.vehicleNo === vehicleNumber ? { ...row, unblockComment: value } : row
      )
    );
  };

  const handleRemoveDoc = (vehicleNumber, fileId) => {
    setRows((prev) =>
      prev.map((row) =>
        row.vehicleNo === vehicleNumber
          ? {
            ...row,
            unblockDocs: (row.unblockDocs || []).filter(
              (d) => d.vehicleBlockrequestFileId !== fileId
            ),
          }
          : row
      )
    );
  };

  const handleDocumentUpload = async (vehicleNumber, files) => {
    if (!files || files.length === 0) return;

    const uploadedDocs = [];

    for (const file of files) {
      try {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("fileName", file.name);
        formData.append("containerName", "pit");

        const res = await apiClient.post(UPLOAD_DCUMENT, formData, {
          headers: {
            AuthKey: authKey,
            "Content-Type": "multipart/form-data",
          },
        });

        uploadedDocs.push({
          unBLockVehicleFileId: res.data?.blobResponse?.blobFileName,
          unBLockVehicleFileName: res.data?.blobResponse?.fileName,
          containerName: "pit",
        });
      } catch (err) {
        toast.error(`Failed to upload ${file.name}`);
      }
    }

    if (uploadedDocs.length > 0) {
      setRows((prev) =>
        prev.map((row) =>
          row.vehicleNo === vehicleNumber
            ? {
              ...row,
              unblockDocs: [...(row.unblockDocs || []), ...uploadedDocs],
            }
            : row
        )
      );
    }
  };

  const viewdownloadDocument = (documentBlobName, finalfileName) => {
    loaderService.showLoader();
    fetch(DOWNLOAD_DOCUMENT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        AuthKey: authKey,
      },
      body: JSON.stringify({
        fileName: documentBlobName,
        containerName: "pit",
        file: "",
      }),
    })
      .then((response) => response.blob())
      .then((blob) => {
        const a = document.createElement("a");
        a.style.display = "none";
        document.body.appendChild(a);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = finalfileName;
        a.click();
        window.URL.revokeObjectURL(url);
        loaderService.hideLoader();
      })
      .catch((error) => {
        console.log(error);
        loaderService.hideLoader();
      });
  };

  const UploadDocsCell = ({ row }) => {
    const rowDocs = row.unblockDocs || [];
    const isDisabled = row.status !== "BLOCKED";

    return (
      <Box
        onClick={(e) => e.stopPropagation()}
        onDoubleClick={(e) => e.stopPropagation()}
        sx={{
          width: "100%",
          py: 1,
        }}
      >
        <Stack spacing={1}>
          <Box>
            <Button
              variant="outlined"
              size="small"
              component="label"
              disabled={isDisabled}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              Upload
              <input
                type="file"
                hidden
                multiple
                onClick={(e) => e.stopPropagation()}
                onChange={(e) => {
                  e.stopPropagation();
                  handleDocumentUpload(
                    row.vehicleNo,
                    Array.from(e.target.files)
                  );
                  e.target.value = null;
                }}
              />
            </Button>
          </Box>

          {rowDocs.length > 0 ? (
            <>
              <Stack
                direction="row"
                flexWrap="wrap"
                gap={1}
                sx={{
                  maxWidth: "100%",
                }}
              >
                {rowDocs.map((doc, index) => (
                  <Box
                    key={`${doc.unBLockVehicleFileId}-${index}`}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      maxWidth: "100%",
                      border: "1px solid #e0e0e0",
                      borderRadius: 2,
                      px: 1,
                      py: 0.5,
                      backgroundColor: "#fff",
                    }}
                  >
                    <DescriptionIcon sx={{ fontSize: 18, color: "text.secondary" }} />
                    <Typography
                      variant="caption"
                      title={doc.unBLockVehicleFileName}
                      sx={{
                        maxWidth: { xs: 150, sm: 220, md: 260 },
                        wordBreak: "break-word",
                        lineHeight: 1.3,
                      }}
                    >
                      {doc.unBLockVehicleFileName}
                    </Typography>
                    <Button
                      size="small"
                      color="error"
                      sx={{ minWidth: "auto", p: 0.25 }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRemoveDoc(row.vehicleNo, doc.unBLockVehicleFileId)
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </Button>
                  </Box>
                ))}
              </Stack>
            </>
          ) : (
            <Typography variant="caption" color="text.secondary">
              No files uploaded
            </Typography>
          )}
        </Stack>
      </Box >
    );
  };

  const ExistingDocsCell = ({ docs }) => {
    if (!docs || docs.length === 0) {
      return (
        <Typography variant="body2" color="text.secondary" sx={{ py: 1 }}>
          -
        </Typography>
      );
    }

    return (
      <Box
        sx={{
          width: "100%",
          py: 1,
        }}
      >
        <Stack spacing={0.75}>
          {docs.map((doc, index) => (
            <Link
              key={index}
              onClick={() =>
                viewdownloadDocument(
                  doc?.vehicleBlockrequestFileId,
                  doc?.vehicleBlockrequestFileName
                )
              }
              underline="hover"
              sx={{
                cursor: "pointer",
                fontSize: 13,
                wordBreak: "break-word",
                lineHeight: 1.4,
              }}
            >
              {doc?.vehicleBlockrequestFileName}
            </Link>
          ))}
        </Stack>
      </Box>
    );
  };

  const ExistingUnblockDocsCell = ({ docs }) => {
    if (!docs || docs.length === 0) {
      return (
        <Typography variant="body2" color="text.secondary" sx={{ py: 1 }}>
          -
        </Typography>
      );
    }

    return (
      <Box
        sx={{
          width: "100%",
          py: 1,
        }}
      >
        <Stack spacing={0.75}>
          {docs.map((doc, index) => (
            <Link
              key={index}
              onClick={() =>
                viewdownloadDocument(
                  doc?.vehicleUnBlockrequestFileId,
                  doc?.vehicleUnBlockrequestFileName
                )
              }
              underline="hover"
              sx={{
                cursor: "pointer",
                fontSize: 13,
                wordBreak: "break-word",
                lineHeight: 1.4,
              }}
            >
              {doc?.vehicleUnBlockrequestFileName}
            </Link>
          ))}
        </Stack>
      </Box>
    );
  };

  const columns = [
    {
      field: "vehicleBlockedRequestNumber",
      headerName: "Vehicle Blocked Request Number",
      minWidth: 220,
      flex: 1,
    },
    {
      field: "vehicleNo",
      headerName: "Vehicle No",
      minWidth: 150,
      flex: 0.8,
    },
    {
      field: "stakeholderUrn",
      headerName: "Transporter",
      minWidth: 160,
      flex: 0.9,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 120,
      flex: 0.6,
      renderCell: (params) => (
        <Chip
          label={params.value}
          color={params.value === "BLOCKED" ? "error" : "success"}
          size="small"
        />
      ),
    },
    {
      field: "vehicleBlockedComment",
      headerName: "Blocked Comment",
      minWidth: 180,
      flex: 1,
    },
    {
      field: "vehicleBlockrequestDocumentList",
      headerName: "Blocked Documents",
      minWidth: 260,
      flex: 1.2,
      sortable: false,
      renderCell: (params) => <ExistingDocsCell docs={params.value || []} />,
    },
    {
      field: "unblockComment",
      headerName: "Unblock Comment",
      minWidth: 240,
      flex: 1.2,
      renderCell: (params) => (
        <TextField
          size="small"
          sx={{m: 1}}
          fullWidth
          multiline
          minRows={2}
          value={
            rows.find((r) => r.id === params.row.vehicleNo)?.unblockComment || ""
          }
          disabled={params.row.isRequestSentForUnblock === true}
          onChange={(e) =>
            handleUnblockCommentChange(params.row.vehicleNo, e.target.value)
          }
          onKeyDown={(e) => e.stopPropagation()}
          onClick={(e) => e.stopPropagation()}
          onDoubleClick={(e) => e.stopPropagation()}
        />
      ),
    },
    {
      field: "documents",
      headerName: "Upload Documents",
      minWidth: 320,
      flex: 1.6,
      sortable: false,
      renderCell: (params) => params.row.isRequestSentForUnblock === true ? <ExistingUnblockDocsCell docs={params.value || []} /> : <UploadDocsCell row={params.row} />,
    },

  ];

  const onConfirmRaiseReq = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);

    try {
      await handleBulkUnblockRequest();
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setConfirmOpen(false);
      setIsApiCalled(false);
    }
  };

  return (
    <>
      <Container maxWidth="xxl">
        <Stack
          direction={{ xs: "column", sm: "row" }}
          mb={1}
          justifyContent="space-between"
        >
          <Typography variant="h4" gutterBottom>
            List of Vehicles
          </Typography>
        </Stack>

        <Card>
          <CardContent>
            <Box style={{ height: 500, width: "100%" }}>
              <DataGrid
                // autoHeight
                rows={rows}
                columns={columns}
                loading={loading}
                pageSize={10}
                rowsPerPageOptions={[10, 20, 50]}
                getRowId={(row) => row?.id}
                checkboxSelection
                disableSelectionOnClick
                disableVirtualization
                isRowSelectable={(params) => params.row.status === "BLOCKED" && params.row.isRequestSentForUnblock !== true}
                selectionModel={selectedRows}
                onSelectionModelChange={(newSelection) => {
                  setSelectedRows(newSelection);
                }}
                getRowHeight={() => "auto"}
              // sx={{
              //   "& .MuiDataGrid-cell": {
              //     alignItems: "flex-start",
              //     py: 1,
              //   },
              //   "& .MuiDataGrid-columnHeaders": {
              //     backgroundColor: "#f8f9fb",
              //   },
              //   "& .MuiDataGrid-row": {
              //     maxHeight: "none !important",
              //   },
              // }}
              />
            </Box>
          </CardContent>
        </Card>

        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={onRaiseUnblockButtonClick}
          >
            Request To Unblock
          </Button>
        </Box>
      </Container>

      <ConfirmationPopover
        onOpen={confirmOpen}
        onConfirm={onConfirmRaiseReq}
        onClose={handleConfirmClose}
        action="Raise Request to Unblock"
      />
    </>
  );
}